import styled from 'styled-components';
import IonTable from '../IonTable';
import Alert from '../Alert';
import { RestartButton, RunButton } from '../Button';
import Checkbox from '../Input/Checkbox';
import useStore, { actions } from '../../store/useStore';
import {
    analysisColumnKeys,
    analysisColumnOptions,
} from '../../store/constants';
import { modelVersions } from '../../services/constants';
import RadioGroup from '../Input/RadioGroup';
import PrintButton from './PrintButton';

const Flexbox = styled.div`
    display: flex;
    gap: 16px;
    position: relative;
`;
const ActionBlock = styled.div`
    width: 100%;
`;

const RightSidePanel = styled.div`
    width: 300px;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const OutputPanelContent = ({
    ionTableColumns,
    ionParameters,
    ionValues,
    runModel,
    busy,
    hasOutput,
    alertText,
}) => {
    const { store, dispatch } = useStore();
    const { modelVersion } = store;
    const { useDrainAnalysis, useDefaultValues } = store.input ?? {};

    const changeAnalysisColumn = (columnToUse) => {
        const nextValue = columnToUse === analysisColumnKeys.drain;
        dispatch(actions.setUseDrainAnalysis(nextValue));
    };

    const changeUseDefaultValues = (nextValue) => {
        dispatch(actions.setUseDefaultvalues(nextValue));
    };

    const selectedColumnOption = useDrainAnalysis
        ? analysisColumnKeys.drain
        : analysisColumnKeys.oneToOneDotFive;

    const hasDefaultValues = true;

    const clearTable = () => {
        dispatch(actions.clearIonValues());
    };

    const empty = Object.values(ionValues).every((values) =>
        Object.values(values).every((val) => !val)
    );

    return (
        <div>
            <PrintButton />
            <Flexbox>
                <IonTable columns={ionTableColumns} data={ionParameters} />
                {!hasOutput && (
                    <RightSidePanel>
                        <ActionBlock className="dont-print">
                            {modelVersion === modelVersions.potplant && (
                                <RadioGroup
                                    label="Type voedingswater-analyse:"
                                    options={analysisColumnOptions}
                                    value={selectedColumnOption}
                                    onChange={changeAnalysisColumn}
                                />
                            )}
                            <Checkbox
                                label="Gebruik standaardwaarden"
                                value={useDefaultValues}
                                onChange={changeUseDefaultValues}
                                disabled={!hasDefaultValues}
                            />
                            <RunButton
                                disabled={busy}
                                busy={busy}
                                onClick={runModel}
                            >
                                {busy
                                    ? 'Berekening wordt uitgevoerd...'
                                    : 'Advies berekenen'}
                            </RunButton>
                            {alertText && <Alert>{alertText}</Alert>}
                        </ActionBlock>
                        <div
                            style={{
                                textAlign: 'right',
                                visibility: empty ? 'hidden' : 'visible',
                            }}
                        >
                            <RestartButton onClick={clearTable}>
                                alles wissen
                            </RestartButton>
                        </div>
                    </RightSidePanel>
                )}
            </Flexbox>
        </div>
    );
};

export default OutputPanelContent;
